var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "7px",
    viewBox: "0 0 6 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7F9AC253-1AD9-4E83-B26F-FAA2806724E5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Overview-&-Analytics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overview-Temporary---GMS",
    transform: "translate(-734.000000, -98.000000)",
    fill: "#404040",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layout",
    transform: "translate(154.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(234.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HC",
    transform: "translate(346.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33333333,4.2 C5.25380792,4.2 6,4.98350169 6,5.95 L6,5.95 L6,6.65 C6,6.84329966 5.85076158,7 5.66666667,7 C5.48257175,7 5.33333333,6.84329966 5.33333333,6.65 L5.33333333,6.65 L5.33333333,5.95 C5.33333333,5.37010101 4.88561808,4.9 4.33333333,4.9 L4.33333333,4.9 L1.66666667,4.9 C1.11438192,4.9 0.666666667,5.37010101 0.666666667,5.95 L0.666666667,5.95 L0.666666667,6.65 C0.666666667,6.84329966 0.51742825,7 0.333333333,7 C0.149238417,7 0,6.84329966 0,6.65 L0,6.65 L0,5.95 C0,4.98350169 0.746192084,4.2 1.66666667,4.2 L1.66666667,4.2 Z M3,0 C3.92047458,0 4.66666667,0.783501688 4.66666667,1.75 C4.66666667,2.71649831 3.92047458,3.5 3,3.5 C2.07952542,3.5 1.33333333,2.71649831 1.33333333,1.75 C1.33333333,0.783501688 2.07952542,0 3,0 Z M3,0.7 C2.44771525,0.7 2,1.17010101 2,1.75 C2,2.32989899 2.44771525,2.8 3,2.8 C3.55228475,2.8 4,2.32989899 4,1.75 C4,1.17010101 3.55228475,0.7 3,0.7 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLight);
export default __webpack_public_path__ + "static/media/user-light.93199982d78d64008fef4851c3acf811.svg";
export { ForwardRef as ReactComponent };